export default {
    create_edit_billing_account_create_title: 'Create Billing Account',
    create_edit_billing_account_edit_title: 'Edit Billing Account',
    create_edit_billing_account_successfully_save: 'The billing account was successfully saved',
    create_edit_billing_account_name: 'Name',
    create_edit_billing_account_name_min_error: 'The name must contain minimum chars',
    create_edit_billing_account_name_max_error: 'The name contain maximum chars',
    create_edit_billing_account_error_save: 'An error occurred while saving the billing account',
    create_edit_billing_account_error_repeated: 'The name of the billing account is already registered',
};